<div class="spinner-container" *ngIf="isSpinning">
    <div class="spinner"></div>
</div>
<!-- <div *ngIf="!isError">
</div> -->
<!-- <div class="container-fluid" *ngIf="isError">
    <div class="row">
        <div class="col-12 error-container">
            <h1 class="error">Verification failled : {{errorMessage}}</h1>
            <a class="go-home" [routerLink]="['/']" routerLinkActive="router-link-active">Go Home</a>
        </div>
    </div>
</div> -->

<!-- <div class="Error-container" id="slideanimation" *ngIf="isError">
    <div class="banner-img  col-md-6  col-12">
        <a style="text-decoration: none;" [routerLink]="['/']">
            <h6 class="Ws-logo-mobile">{{constants.WINDOW_SWAP_TXT}}</h6>
        </a>
        <img [src]="constants.ERROR_IMG" alt="">
    </div>

    <div class=" col-md-6 col-12">
        <a style="text-decoration: none;" [routerLink]="['/']">
            <h6 class="Ws-logo">{{constants.WINDOW_SWAP_TXT}}</h6>
        </a>
        <div class="msgtext">
            {{constants.ALREADY_TEXT_VERIFY}} <br>
            {{constants.ALREADY_TEXT_VERIFY_1}} <br>
            {{constants.ALREADY_TEXT_VERIFY_2}}
            <p>{{constants.ALREADY_TEXT_VERIFY_3}}</p>

            <button class="login-btn-mobile" [routerLink]="['/login']">Login</button>
        </div>
    </div>
</div> -->

<div class="Error-container" id="slideanimation" *ngIf="!isSpinning">
    <div class="banner-img  col-md-6  col-12">
        <a style="text-decoration: none;" [routerLink]="['/']">
            <h6 class="Ws-logo-mobile">{{constants.WINDOW_SWAP_TXT}}</h6>
        </a>
        <img [src]="constants.ERROR_IMG" alt="">
    </div>

    <div class=" col-md-6 col-12">
        <a style="text-decoration: none;" [routerLink]="['/']">
            <h6 class="Ws-logo">{{constants.WINDOW_SWAP_TXT}}</h6>
        </a>
        <div class="msgtext">
            <p *ngIf="isSuccess && !isAppSignup">{{firstTimeUser}} <br> {{firstTimeUserSub}}</p>
            <p *ngIf="isSuccess && isAppSignup">{{firstTimeUser}} <br> {{firstTimeUserSub}}</p>
            <p *ngIf="isError && !isUnknownError">{{errorMessage}} <br> {{errorMessageSub}} </p>
            <p *ngIf="isUnknownError" class="bold">{{errorMessage}}</p>
            <p *ngIf="isUnknownError" class="thin" style="margin-top: 0px;">{{errorMessageSub}}</p>
            <div class="copy-error" *ngIf="isUnknownError" (click)="copyText()">
                <span>Copy Error Report</span>
            </div>
            <p class="prefer-web-text" *ngIf = "!isUnknownError && isAppSignup">Prefer web? <u [routerLink]="['/login']">Click
                here to login</u></p>
            <!-- <div class="query animate__animated" *ngIf="isUnknownError">
                <img src="{{ constants.MAIL_IMG }}" />
                <div>{{constants.QUERY_TXT}}</div>
                <a href="mailto:{{constants.QUNALIAA_EMAIL_TXT}}" target="_blank">{{constants.QUNALIAA_EMAIL_TXT}}</a>
            </div> -->
            <!-- This email has already been verified.<br> Use it to login below. -->
            <!-- <p>Please use it to log in</p> -->
            <form [formGroup]="loginForm"
                *ngIf="!isAppSignup && ((!isUnknownError && isError) || (isSuccess && !isError && !isUnknownError))">
                <span id="errorAlert"></span>
                <span id="resend">User is not confirmed.<button [disabled]="isLoading" class='resend'
                        (click)='onClickResend()'>Resend verification code
                        Confirmation.</button></span>
                <span class="input-text-required"
                    *ngIf="loginForm.get('email').errors?.required && (loginForm.get('email').dirty || loginForm.get('email').touched)">
                    Please enter an email ID<br></span>
                <span class="input-text-required" *ngIf="loginForm.get('email').errors?.email">
                    Invalid email ID </span>
                <input type="email" class="input-text animate__animated animate__fadeInUp"
                    placeholder="Your Email Address" formControlName="email">
                <span class="input-text-required"
                    *ngIf="loginForm.get('password').errors?.required && (loginForm.get('password').dirty || loginForm.get('password').touched)">
                    Please enter a password </span>
                <div class="password-container animate__animated animate__fadeInUp">
                    <input class="input-text " id="input-password" type="password" placeholder="Password"
                        formControlName="password">
                    <i (click)="onClickSowPassowrd()" class="fa fa-eye password-show"></i>
                </div>
                <button [disabled]="isProcessing || !loginForm.valid"
                    class="login-btn animate__animated animate__fadeInUp" (click)="onClicklogin()">
                    <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span> Login </button>
            </form>
            <button *ngIf="!isUnknownError && !isAppSignup" [disabled]="isProcessing || !loginForm.valid"
            class="login-btn-mobile animate__animated animate__fadeInUp" (click)="onClicklogin()">
            <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
            aria-hidden="true"></span> Login </button>
        </div>
    </div>
</div>

<div class="footer" *ngIf="errorCopied">
<span>{{constants.REPORT_COPIED}}</span>
</div>